/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { uploadFiles } from '../../../api';
import style from './GenioModal.module.scss';
import style2 from '../../../styles/Accordion.module.scss';
import { containsDisallowedDomain, fileAllowedTypes, getImgSrcUrl, validateURL } from '../../../lib/common';

const GenioModal = ({
  setDispositionComment,
  handleClosePopup,
  genioReopenRef,
  setAlert,
  handleDispositionCommentSubmit,
}) => {
  const [issueCommentObj, setIssueCommentObj] = useState({ issueComment: '', urlInput: '' });
  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showErr, setShowErr] = useState(false);
  const [isValidURL, setIsValidURL] = useState(false);

  useEffect(() => {
    const isValid = validateURL(issueCommentObj.urlInput, 'genioContentUrl');
    setIsValidURL(isValid);
    if (issueCommentObj.urlInput) {
      setShowErr(containsDisallowedDomain(issueCommentObj.urlInput));
    }
  }, [issueCommentObj?.urlInput]);

  if (issueCommentObj?.urlInput) {
    setDispositionComment(`${issueCommentObj.issueComment}. URL: ${issueCommentObj.urlInput}`);
  } else {
    setDispositionComment(`${issueCommentObj.issueComment}`);
  }

  const handleInputChange = (val, inputType) => {
    setIssueCommentObj((prevState) => ({ ...prevState, [inputType]: val }));
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file && fileAllowedTypes.includes(file.type)) {
      const maxFileSize = file?.type === 'video/mp4' ? 50 : 5;
      if (file && file.size > maxFileSize * 1024 * 1024) {
        setAlert({
          message: `File size should not exceed ${maxFileSize} MB`,
          status: false,
        });
      } else {
        const files = event.target.files ? [...event.target.files] : [];
        const tempFileData = [...fileData];
        try {
          setLoading(true);
          const response = await uploadFiles(files, true);
          if (response.error_code === 0) {
            if ((response.image_urls && response.image_urls.length > 0) || file?.type === 'video/mp4') {
              tempFileData.push({
                name: files[0].name,
                url: file?.type === 'video/mp4' ? response?.url : response.image_urls[0],
              });
              setFileData(tempFileData);
            }
          } else {
            setAlert({
              message: 'Invalid file format',
              status: false,
            });
          }
          setLoading(false);
        } catch (err) {
          console.log('Error: ', err);
        }
      }
    } else {
      setAlert({
        message: 'Invalid file type. Please upload an Image, Excel, Word, PDF or Video(mp4) file.',
        status: false,
      });
    }
  };

  const handleFileDelete = (fileIndex) => {
    const tempFileData = [...fileData];
    tempFileData.splice(fileIndex, 1);
    setFileData(tempFileData);
  };
  const enableButton =
    issueCommentObj?.issueComment?.trim()?.length > 2 &&
    (issueCommentObj?.urlInput === '' || (issueCommentObj?.urlInput && isValidURL)) &&
    !loading;

  const handleSubmit = () => {
    handleDispositionCommentSubmit(fileData);
    setFileData([]);
    setIssueCommentObj({});
  };

  return (
    <section className={`cs_modal ${style.Modal}`}>
      <div ref={genioReopenRef} className={`cs_modal_content cs_modal_animation cs_modal_up ${style.Modal__Content} `}>
        <div className={`${style.Modal__Body} cs_modal_body p-20`}>
          <div className="cs_modal_header">
            <div className="cs_modal_head_center">
              <div className="font14 fw400 color111 pr-10 pt-10" style={{ display: 'flex' }}>
                To understand better, please help us with the reason
                <div className="modal_close csicon" onClick={() => handleClosePopup()} style={{ cursor: 'pointer' }} />
              </div>
            </div>
          </div>

          <div className={`${style.AreaBox} mt-20`}>
            <div className="font13 fw400 color111">What went wrong with given solution?</div>
            <textarea
              value={issueCommentObj.issueComment}
              onChange={(e) => handleInputChange(e.target.value, 'issueComment')}
              className={`${style.TextArea} font13 fw400 color111 mt-12`}
            />
          </div>

          <div className={`${style.AddUrl} mt-15`}>
            <input
              value={issueCommentObj.urlInput}
              onChange={(e) => handleInputChange(e.target.value, 'urlInput')}
              type="search"
              placeholder="Add url"
              className={`${style.AddUrlInput} font13 fw400 color111`}
            />
            {issueCommentObj?.urlInput && !isValidURL && (
              <span className="colorEC4 font12">Please enter valid url</span>
            )}
            <br />
            {showErr && <span className="colorEC4 font12">Please avoid third party website addresses.</span>}
          </div>

          <div className={`${style.UploadDetails} mt-15`}>
            <div className={`${style.UploadBox}`}>
              {fileData && fileData.length > 0 ? (
                <ul className={`${style.UploadList}`}>
                  {fileData.map((each, idx) => (
                    <li className={`${style.UploadItem}`} key={idx}>
                      <div className={`${style.UploadImage}`}>
                        <img
                          alt={each.name}
                          src={
                            each?.url.endsWith('.xlsx')
                              ? 'https://images.jdmagicbox.com/standard/cs_module/c55c4df230df37ac6f72407f8edc40ff.jpg'
                              : getImgSrcUrl(each.url)
                          }
                          className={`${style.UploadImg}`}
                        />
                      </div>
                      <div
                        className={`${style.UploadText} font12 fw400 color111 ${
                          fileData.length > 1 ? 'pl-12 pr-12' : 'pl-10 pr-10'
                        }`}
                      >
                        {each.name}
                      </div>
                      <div
                        onClick={() => handleFileDelete(idx)}
                        className={`${style.UploadAnchor} font12 fw500 color007 ${fileData.length > 1 ? 'mr-10' : ''}`}
                      >
                        Delete
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                loading && <span className="">{/* <Loader loading={loading} /> */}</span>
              )}

              <label htmlFor="upldImg" className={`${style.UploadButton} bluefill_animate mt-12`}>
                <input
                  onChange={handleFileUpload}
                  id="upldImg"
                  className={`${style.UploadButton__Input} `}
                  type="file"
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                  name=""
                />
                <div className={`${style.UploadButton__Icon} csicon mr-6`} />
                <div className="font14 fw500 colorFFF">Upload</div>
              </label>
              <div className="font11 fw400 color777 mt-8 text_center">
                Upload of all kind of documents i.e. photo/excel/pdf etc. within 5mb.{' '}
              </div>
            </div>
          </div>
          <button
            type="button"
            className={`${style2.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-10`}
            style={{
              backgroundColor: `${enableButton ? '#0076d7' : '#CCCCCC'}`,
              border: `1px solid ${!enableButton ? '#E0E0E0' : '#CCCCCC'}`,
              transitionProperty: 'background-color, background-image, border-color, box-shadow',
              transition: 'all 0.8s',
              color: `#FFFFFF`,
            }}
            disabled={!enableButton}
            onClick={() => handleSubmit()}
          >
            Submit
          </button>
        </div>
      </div>
    </section>
  );
};

export default GenioModal;

GenioModal.propTypes = {
  handleClosePopup: PropTypes.func,
  genioReopenRef: PropTypes.object,
  setDispositionComment: PropTypes.func,
  setAlert: PropTypes.func,
  handleDispositionCommentSubmit: PropTypes.func,
};
